<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div style="display: flex;justify-content: flex-start;align-items: center;"></div>
      <input-search :placeholder="searchPlaceholder" @search="search" />
          <button-export
          style="margin-left: 5px"
          :href="exportUrl"
          :beforeDownload="beforeDownload"
          download="download.xls"
          v-if="permissionCodes.indexOf('004021001') !== -1"
          value="导出"/>
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" :hasOperation="false" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" />
  </div>
</template>

<script>
import Breadcrumb from "../../../../components/Breadcrumb/Breadcrumb";
import ButtonAdd from "../../../../components/Button/ButtonAdd";
import ButtonExport from "../../../../components/common/buttons/button-export";
import InputSearch from "../../../../components/Input/InputSearch";
import TableMain from "../../../../components/Table/TableMain";
import { api } from "../../../api/ParkingService";
import { errorHandler } from "../../../../utils/errorHandler";
import { nSuccess } from "../../../../utils/notice";
import { bus } from "../../../../utils/bus";
import ButtonCancel from "../../../../components/Button/ButtonCancel";

export default {
  components: {
    ButtonCancel,
    TableMain,
    ButtonExport,
    InputSearch,
    ButtonAdd,
    Breadcrumb
  },
  name: "coupon-usage-record",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "智慧停车",
          name: "parking-device-management"
        },
        {
          value: "优惠券使用记录"
        }
      ],
      searchPlaceholder: "车牌号/商户名称",
      searchKey: "",
      exportUrl: "",
      tableHead: [
        {
          prop: "carNumber",
          label: "车牌号"
        },
        {
          prop: "enterpriseName",
          label: "商户名称"
        },
        {
          prop: "couponName",
          label: "优惠券名称"
        },
        {
          prop: "couponType",
          label: "优惠券类型"
        },
        {
          prop: "providerPersonName",
          label: "发放人"
        },
        {
          prop: "providerTime",
          label: "发券时间"
        },
        {
          prop: "useTime",
          label: "使用时间"
        },
        {
          prop: "status",
          label: "状态"
        }
      ],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      requestData: {
        searchKey: ""
      }
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.getPage();
  },
  activated() {
    this.getPage();
  },
  methods: {
    beforeDownload() {
      this.exportUrl = `${api.exportParkingCouponUseageRecord}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${this.requestData.searchKey}`;
    },
    getPage() {
      this.$axios
        .post(api.parkingCouponUseageRecordGetPage, {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          searchKey: this.searchKey
        })
        .then(res => {
          if (res.data.retCode === 1) {
            this.total = res.data.data.total;
            let data = res.data.data.list;
            this.tableData = data;
          }
        })
        .catch(errorHandler("获取信息失败"));
    },
    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    },
    search(v) {
      this.pageNum = 1;
      this.searchKey = v;
      this.getPage();
    }
  }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: flex-end;
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/ParkingCoupon/CouponUsageRecord/CouponUsageRecord.vue